"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBrandEmail = void 0;
const Alignment_1 = require("../../enums/Alignment");
exports.defaultBrandEmail = {
    sender: 'info',
    headerTextStyle: {
        color: '000000',
        font: 'arial',
        fontSize: '24px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    bodyTextStyle: {
        color: '000000',
        font: 'arial',
        fontSize: '17px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    buttonStyle: {
        color: 'FFFFFF',
        font: 'arial',
        backgroundColor: '58BFEC',
        borderRadius: '0px',
    },
    topImageUrl: 'https://dwfedcf5lscmq.cloudfront.net/studio/cms/mail_top.png',
    bottomImageUrl: 'https://dwfedcf5lscmq.cloudfront.net/studio/cms/mail_bot.png',
};
